var map = {
	"./csm.png": 8205,
	"./dem.png": 853,
	"./engm.png": 4398,
	"./plm.png": 9636,
	"./prem.png": 1232,
	"./rum.png": 4898,
	"./skm.png": 5249,
	"./unknownm.png": 1689
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5419;